import { WorkoutLogsModalComponent } from './PatientSheetView/workout-logs-modal/workout-logs-modal.component';
import { WorkoutService } from './../../@core/backend/common/services/CalorieFriend/workout.service';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { ChartModule } from 'angular2-chartjs';
import { VirtualScrollerModule } from 'ngx-virtual-scroller';
import { NgxMaterialTimepickerModule } from 'ngx-material-timepicker';
import { OwlDateTimeModule, OwlNativeDateTimeModule } from 'ng-pick-datetime';
import { NgxIntlTelInputModule } from 'ngx-intl-tel-input';
import { GaugeModule } from "angular-gauge";
import {
  NbTabsetModule,
  NbToggleModule,
  NbSelectModule,
  NbProgressBarModule,
  NbDialogModule,
  NbPopoverModule,
  NbFormFieldModule,
  NbAutocompleteModule,
  NbAccordionModule,
  NbIconModule,
  NbCardModule,
  NbInputModule,
  NbSpinnerModule,
  NbRadioModule,
  NbDatepickerModule,
  NbCheckboxModule,
  NbButtonModule,
  NbAlertModule,
  NbThemeService,
  NbUserModule,
  NbCalendarModule,
  NbBadgeModule,
  NbTooltipModule
} from '@nebular/theme';
import { NbEvaIconsModule } from '@nebular/eva-icons';
import { JoyrideModule } from 'ngx-joyride';
import { Ng2SmartTableModule } from 'ng2-smart-table';
import { ImageCropperModule } from 'ngx-image-cropper';
import { CalendarModule, DateAdapter } from 'angular-calendar';
import { adapterFactory } from 'angular-calendar/date-adapters/date-fns';

import { MaterialModule } from 'app/@components/material.module';
import { ComponentsModule } from '../../@components/components.module';
import { GraphModule } from 'app/admin/public-foods/meal-metrics-graph/meal-metrics-graph.module';
import { MealPresentationModule } from './Plans/PlanMeals/Meal/MealLayout/MealPresentation/meal-presentation.module';
import { MealItemsPresentationModule } from './Plans/PlanMeals/Meal/MealLayout/MealItemsPresentation/meal-items-presentation.module';
import { MealItemPresentationModule } from './Plans/PlanMeals/Meal/MealLayout/MealItemPresentation/meal-item-presentation.module';
import { CalorieFriendRoutingModule } from './calorie-friend-routing.module';

import { CalorieFriendComponent } from './calorie-friend.component';
import { PatientsComponent } from './Patients/patients.component';
import { PatientComponent } from './Patient/patient.component';
import { PaymentInfoComponent } from './Dashboard/payment-info/payment-info.component';
import { GoalListComponent } from './Goals/GoalList/goal-list.component';
import { GoalDefComponent } from './Goals/GoalDef/goal-def.component';
import { SectionLayoutComponent } from './Patients/SectionLayout/section-layout.component';
import { PlanListComponent } from './Plans/PlanList/plan-list.component';
import {
  MealPlanDefComponent,
  MealPlanViewComponent,
  EditMealPlanDefComponent,
  PlanDayLabelComponent,
  AddMealPlanDefComponent,
} from './Plans/PlanDef/plan-def.component';
import { MealComponent } from './Plans/PlanMeals/Meal/meal.component';
import {
  MealPlanDayComponent,
  MealPlanDayStaticComponent,
  MealPlanDayReportComponent,
  MealPlanDayDialogComponent,
  MealPlanDayMobileLayoutComponent,
} from './Plans/PlanDay/plan-day.component';
import { MealItemsComponent } from './Plans/PlanMeals/MealItems/meal-items.component';
import { MealQuantityComponent } from './Plans/PlanMeals/Meal/MealQuantity/meal-quantity.component';
import {
  FitnessPlanTemplateSelectComponent,
  PlanTemplateSelectComponent,
  TemplateNameComponent,
} from './Plans/PlanTemplate/ListSelection/plan-template-select.component';
import { TemplateGenerateComponent } from './Plans/PlanList/template-generate.component';
import { TempGoalListComponent } from './Goals/TempGoalList/temp-goal-list.component';
import { TempGoalDefComponent } from './Goals/TempGoalDef/temp-goal-def.component';
import { ServingSizeComponent } from './Plans/PlanMeals/Meal/ServingSize/serving-size.component';
import {
  ServingSizeSelectionComponent,
  ServingSizeSelectionDiaryComponent,
} from './Plans/PlanMeals/Meal/ServingSize/Selection/serving-size-selection.component';
import { NutritionalFactsComponent } from './Plans/PlanMeals/Meal/NutritionalFacts/nutritional-facts.component';
import { ItemPortionsComponent } from './Plans/PlanMeals/Meal/ItemPortions/item-portions.component';
import { PatientGeneralInfoComponent } from './PatientSheetView/patient-general-info/patient-general-info.component';
import { GoalsListViewComponent } from './PatientSheetView/GoalsListView/goals-list-view.component';
import { MealViewerComponent } from './Plans/Viewer/View/meal-viewer.component';
import { PatientProgressComponent } from './PatientSheetView/patient-progress/patient-progress.component';
import { CustomPatientNameFieldComponent } from './Patients/CustomPatientNameField/CustomPatientNameField.component';
import { ReportMealPlanViewComponent } from './Plans/PlanDef/plan-def.component';
import {
  PatientProfileComponent,
  PatientProfileAnonymousComponent,
} from './Plans/Viewer/PatientProfile/patient-profile.component';
import { AssessmentInputComponent } from './Customers/Assessments/assessment.component';
import { PlanDataService } from './Plans/PlanDef/PlanService';
import { UpgradePlanComponent } from './Patients/UpgradePlan/upgrade-plan.component';
import { InitialUserInfoComponent } from './InitialUserInfo/initial-user-info.component';
import { SubscriptionPlanComponent } from './SubscriptionPlan/subscription-plan.component';
import { TutorialFinalModalComponent } from './tutorial-final-modal/TutorialFinalModal.component';
import {
  AddFitnessPlanDefComponent,
  EditFitnessPlanDefComponent,
  FitnessPlanDefComponent,
} from './FitnessPlans/PlanDef/fitness-plan-def.component';
import {
  DayFitnessSummaryComponent,
  FitnessSummaryComponent,
} from './FitnessPlans/FitnessSummary/fitness-summary.component';
import {
  FitnessPlanDayComponent,
  FitnessPlanDayMobieComponent,
} from './FitnessPlans/PlanDay/fitness-plan-day.component';
import { ExerciseEditComponent } from './FitnessPlans/ExerciseEdit/exercise-edit.component';
import {
  FitnessBlockComponent,
  FitnessBlockMobileComponent,
} from './FitnessPlans/FitnessBlock/fitness-block.component';
import {
  FitnessItemsListPresentationComponent,
  FitnessItemsListPresentationMobileComponent,
} from './FitnessPlans/FitnessItemsListPresentation/fitness-items-list-presentation.component';
import { FitnessItemPresentationComponent } from './FitnessPlans/FitnessItemPresentation/fitness-item-presentation.component';
import { OverlayFitnessItemPresentationComponent } from './FitnessPlans/FitnessItemPresentation/fitness-item-presentation-overlay.component';
import { AddFitnessItemsComponent } from './FitnessPlans/AddFitnessItems/add-fitness-items.component';
import { FitnessPlanTemplateCreateComponent } from './FitnessPlans/plan-template-create/plan-template-create.component';
import { FitnessPlanTemplatesComponent } from './Plans/fitness-plan-templates/templates.component';
import { FitnessPlanTemplateResolver } from './Plans/fitness-plan-templates/template.resolver';
import { CustomExerciseListComponent } from './custom-exercise/exercise-list/exercise-list.component';
import { CustomExerciseDefComponent } from './custom-exercise/CustomExerciseDef/customexercise-def.component';
import { PatientExerciseProgressListComponent } from './PatientSheetView/exercise-progress-list/exercise-progress-list.component';
import { EditAssessmentComponent } from './PatientSheetView/Assessments/edit-assessment.component';
import { PatientSheetViewComponent } from './PatientSheetView/patient-sheet-view.component';
import { ThemeModule } from 'app/@theme/theme.module';
import { PatientBiometricHistoryListComponent } from './PatientSheetView/biometric-history-list/biometric-history-list.component';
import { PatientAssessmentListComponent } from './PatientSheetView/assessment-list/assessment-list.component';
import { PlanTemplateListComponent } from './Plans/template-list/template-list.component';
import { MealPlanTemplatesComponent } from './Plans/meal-plan-templates/templates.component';
import { MealPlanTemplateResolver } from './Plans/meal-plan-templates/template.resolver';
import { FoodListComponent } from './custom-foods/food-list/food-list.component';
import { CustomFoodsComponent } from './custom-foods/custom-foods.component';
import { BrandComponent } from './brand/brand.component';
import { PremiumModalComponent } from './premium-modal/premium-modal.component';
import { PremiumTrialReminderComponent } from './premium-trial-reminder/premium-trial-reminder.component';
import { AssingPlanClientComponent } from './assing-plan-client/assing-plan-client.component';
import { HelpGuidesComponent } from './help-guides/help-guides.component';
import { PlanListItemComponent } from './PatientSheetView/patient-program/plan-list-item/plan-list-item.component';
import { PatientCalendarModalComponent } from './PatientSheetView/calendar-modal/calendar-modal.component';
import { PatientProgramComponent } from './PatientSheetView/patient-program/patient-program.component';
import { HowToModalComponent } from './how-to-modal/how-to-modal.component';
import { HowToModalComponentDialog } from './how-to-modal/how-to-modal.component';
import { FitnessWorkoutComponent } from './FitnessPlans/FitnessWorkout/fitness-workout.component';
import { FitnessWorkoutOverlayComponent } from './FitnessPlans/FitnessWorkout/FitnessWorkoutOverlay/fitness-workout-overlay.component';
import { FitnessWorkoutLogItemComponent } from './FitnessPlans/FitnessWorkoutLogItem/fitness-workout-log-item.component';
import { ExerciseService } from 'app/@core/backend/common/services/CalorieFriend/exercise-service';
import { ExerciseLogService } from 'app/@core/backend/common/services/CalorieFriend/exerciseLog-service';
import { FoodDiaryLogModalComponent } from './PatientSheetView/food-diary-log-modal/food-diary-log-modal.component';
import { FoodDiaryAppComponent } from 'app/frontends/food-tracking/food-diary-app/food-diary-app.component';
import { ProgramOverviewComponent } from './PatientSheetView/program-overview/program-overview.component';
import { PaymentSettingsService } from 'app/@core/backend/common/services/CalorieFriend/payment-settings.service';
import { InvoicesService } from 'app/@core/backend/common/services/CalorieFriend/invoices.service';
import { RecurringInvoicesService } from 'app/@core/backend/common/services/CalorieFriend/recurring-invoices.service';
import { PatientsService } from 'app/@core/backend/common/services/CalorieFriend/patients.service';
import { MacroGoalsComponent } from './PatientSheetView/macro-goals/macro-goals.component';
import { BillingComponent } from './billing/billing.component';
import { PaymentSettingsComponent } from './billing/payment-settings/payment-settings.component';
import { PatientSubscriptionsMetaService } from 'app/@core/backend/common/services/CalorieFriend/patient-subscriptions-meta.service';
import { PatientSubscriptionsDataService } from 'app/@core/backend/common/services/CalorieFriend/patient-subscriptions-data.service';
import { GramConverterPipe } from 'app/@theme/pipes';
import { ProgramTemplatesComponents } from './program-templates/program-templates.component';
import { ProgramTemplateCreateComponent } from './program-templates/program-template-create/program-template-create.component';
import { ProgramTemplateEditComponent } from './program-templates/program-template-edit/program-template-edit.component';
import { AssessmentSettingComponent } from './assessmentSetting/assessmentSetting.component';
import { FormlyNebularModule } from 'app/@theme/formly/formly-nebullar.module';
import { AssessmentFormSettingsComponent } from './assessmentSetting/assessmentFormSettings.component';
import { AngularEditorModule } from '@kolkov/angular-editor';
import { WorkoutLogsDetailsComponent } from './PatientSheetView/workout-logs-modal/workout-logs-details/workout-logs-details.component';
import { AppSettingsComponent } from 'app/@components/app-settings/app-settings.component';

const NB_MODULES = [
  NbButtonModule,
  NbInputModule,
  NbTabsetModule,
  NbToggleModule,
  NbSelectModule,
  NbProgressBarModule,
  NbPopoverModule,
  NbDialogModule.forChild(),
  NbFormFieldModule,
  NbEvaIconsModule,
  NbAutocompleteModule,
  NbAccordionModule,
  NbIconModule,
  NbCardModule,
  NbAlertModule,
  NbSpinnerModule,
  NbRadioModule,
  NbCalendarModule,
  NbDatepickerModule,
  NbCheckboxModule,
  NbBadgeModule,
  NbTooltipModule
];

const MAT_MODULES = [MaterialModule];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    CalorieFriendRoutingModule,
    ThemeModule,
    ComponentsModule,
    NbUserModule,
    AngularEditorModule,
    ...NB_MODULES,
    ...MAT_MODULES,
    GraphModule,
    MealPresentationModule,
    MealItemPresentationModule,
    MealItemsPresentationModule,
    Ng2SmartTableModule,
    NgxMaterialTimepickerModule,
    OwlDateTimeModule,
    OwlNativeDateTimeModule,
    NgxChartsModule,
    VirtualScrollerModule,
    DragDropModule,
    ChartModule,
    JoyrideModule.forChild(),
    ImageCropperModule,
    CalendarModule.forRoot({
      provide: DateAdapter,
      useFactory: adapterFactory,
    }),
    NgxIntlTelInputModule,
    GaugeModule.forRoot(),
    FormlyNebularModule,
  ],
  declarations: [
    CalorieFriendComponent,
    PatientsComponent,
    PatientComponent,
    GoalListComponent,
    GoalDefComponent,
    SectionLayoutComponent,
    PlanListComponent,
    MealPlanDefComponent,
    MealComponent,
    MealPlanDayComponent,
    MealPlanDayMobileLayoutComponent,
    MealItemsComponent,
    MealQuantityComponent,
    PlanTemplateSelectComponent,
    TemplateNameComponent,
    PaymentInfoComponent,
    TemplateGenerateComponent,
    TempGoalListComponent,
    TempGoalDefComponent,
    ServingSizeComponent,
    ServingSizeSelectionComponent,
    ServingSizeSelectionDiaryComponent,
    NutritionalFactsComponent,
    ItemPortionsComponent,
    CustomPatientNameFieldComponent,
    PatientGeneralInfoComponent,
    GoalsListViewComponent,
    PatientProgressComponent,
    MealPlanTemplatesComponent, // @Vinicius
    PlanTemplateListComponent, // @Vinicius
    MealViewerComponent,
    MealPlanDayStaticComponent,
    ReportMealPlanViewComponent,
    MealPlanViewComponent,
    MealPlanDayReportComponent,
    PatientProfileComponent,
    PatientProfileAnonymousComponent,
    AssessmentInputComponent,
    EditMealPlanDefComponent,
    PlanDayLabelComponent,
    MealPlanDayDialogComponent,
    AddMealPlanDefComponent,
    UpgradePlanComponent,
    InitialUserInfoComponent,
    SubscriptionPlanComponent,
    TutorialFinalModalComponent,
    FitnessPlanDayMobieComponent,
    AddFitnessPlanDefComponent,
    EditFitnessPlanDefComponent,
    FitnessSummaryComponent,
    DayFitnessSummaryComponent,
    FitnessPlanDayComponent,
    FitnessPlanDefComponent,
    FitnessBlockComponent,
    FitnessBlockMobileComponent,
    FitnessItemsListPresentationComponent,
    FitnessItemsListPresentationMobileComponent,
    FitnessItemPresentationComponent,
    ExerciseEditComponent,
    AddFitnessItemsComponent,
    FitnessPlanTemplateCreateComponent,
    ProgramTemplateCreateComponent,
    ProgramTemplateEditComponent,
    FitnessPlanTemplatesComponent, // @Vinicius
    FitnessPlanTemplateSelectComponent,
    CustomExerciseListComponent, // @Vinicius
    CustomExerciseDefComponent,
    OverlayFitnessItemPresentationComponent,
    PatientExerciseProgressListComponent, // @Milos
    PatientBiometricHistoryListComponent, // @Vinicius
    PatientAssessmentListComponent, // @Vinicius
    EditAssessmentComponent,
    PatientSheetViewComponent,
    FoodListComponent, // @Vinicius
    CustomFoodsComponent,
    BrandComponent,
    PremiumModalComponent,
    PremiumTrialReminderComponent,
    AssingPlanClientComponent,
    HelpGuidesComponent, // @Vinicius
    PatientProgramComponent, // @Vinicius
    PlanListItemComponent, // @Vinicius
    PatientCalendarModalComponent,
    WorkoutLogsModalComponent, //@Intel
    WorkoutLogsDetailsComponent,
    HowToModalComponent,
    HowToModalComponentDialog, // @Vinicius
    FitnessWorkoutComponent, //@Intel
    FitnessWorkoutOverlayComponent, // @Intel
    FitnessWorkoutLogItemComponent,
    FoodDiaryLogModalComponent,
    FoodDiaryAppComponent,
    ProgramOverviewComponent, //@Intel
    MacroGoalsComponent,
    BillingComponent,
    PaymentSettingsComponent,
    ProgramTemplatesComponents,
    AssessmentSettingComponent,
    AssessmentFormSettingsComponent,
    AppSettingsComponent,
  ],
  providers: [
    PlanDataService,
    MealPlanTemplateResolver,
    FitnessPlanTemplateResolver,
    WorkoutService,
    ExerciseService,
    ExerciseLogService,
    PaymentSettingsService,
    InvoicesService,
    RecurringInvoicesService,
    PatientsService,
    PatientSubscriptionsMetaService,
    PatientSubscriptionsDataService,
    GramConverterPipe,
  ],
  exports: [
    PatientGeneralInfoComponent,
    GoalsListViewComponent,
    PatientProgressComponent,
    DayFitnessSummaryComponent,
    FitnessSummaryComponent,
    FitnessItemPresentationComponent,
    MealPlanDayMobileLayoutComponent,
    FitnessPlanDayMobieComponent,
    FitnessWorkoutLogItemComponent,
    AssessmentInputComponent,
    FoodDiaryAppComponent,
  ],
})
export class CalorieFriendModule {
  ActivePatient: number = -1;

  constructor(private themeService: NbThemeService) {
    this.themeService.changeTheme('default');
  }
}
